// extracted by mini-css-extract-plugin
module.exports = {"terms_container":"TermsDisclaimer_terms_container__hvoST","terms_link":"TermsDisclaimer_terms_link__Y41tg","shadow":"TermsDisclaimer_shadow__vh79T"};